






































import { Vue, Component } from 'vue-property-decorator';
import { detail } from '@/api/api.ts';
import * as config from './config';
import { appShare, wxShareInfo } from '@/common/ts/common';
import VoteButton from '@/components/VoteButton.vue';
import SyPlayer from '@/components/SyPlayer.vue';
@Component({
  components: {
    VoteButton,
    SyPlayer,
  },
})
export default class FirstDetail extends Vue {
  detailData: any = {};
  created() {
    detail(config.OPTHINES.voteName, this.$route.query.id).then((res) => {
      this.detailData = res.data;
    });

    // 分享
    appShare({
      title: 'Break the Limit-创·无界首届国际青年短视频大赛',
      url: window.location.href,
      subtitle: 'Break the Limit-创·无界首届国际青年短视频大赛',
      classId: -1,
      id: -1,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: 'Break the Limit-创·无界首届国际青年短视频大赛',
      subtitle: 'Break the Limit-创·无界首届国际青年短视频大赛',
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  enterOtherPage() {
    window.location.href = this.detailData.url;
  }
  handleSuccess() {
    console.log('投票成功');
  }
}
